<template>
  <main>
    <b-table
      :busy.sync="busy"
      :current-page="currentPage"
      :fields="myAccess()"
      :items="requests"
      :per-page="perPage"
      :tbody-tr-class="rowClass"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      class="table-row-text"
      empty-text="There are no data to show."
      hover
      outlined
      primary-key="Id"
      responsive
      show-empty
      stacked="sm"
      style="border-radius: 3px !important"
    >
      <template #table-caption>
        <div class="px-3" style="display: flex; justify-content: space-between">
          <p v-if="requests.length > 1" style="font-size: 14px">
            <strong>{{ totalRows }}</strong>
            {{ totalRows > 1 && totalRows !== 0 ? 'requests' : 'request' }}
          </p>
          <p>Timezones are in GMT</p>
          <b-pagination
            v-if="totalRows > perPage"
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="totalRows"
            align="center"
            aria-controls="my-cam"
            pills
            size="sm"
          ></b-pagination>
          <p v-else>&nbsp;</p>
        </div>
      </template>
      <template v-slot:head()="data">
        <div class="my-team-table-header">
          {{ data.label }}
        </div>
      </template>
      <template #table-busy>
        <div class="text-center text-secondary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
      <template #cell(accountStatus)="row">
        <status :status="row.item['accountStatus']" />
      </template>
      <template #cell(requestType)="row">
        {{ row.item['requestType'] }}
        <span
          v-if="
            row.item['requestType'] === 'Delete Request' ||
              row.item['requestType'] === 'Deactivate Request'
          "
          >({{ row.item['deleteReason'] }})</span
        >
      </template>
      <template #cell(statusMap)="row">
        <div class="inline-block text-nowrap">
          <new-status-map
            :status="row.item['statusMap']"
            :pendingReason="row.item['pendingReason']"
          >
            <template #pendingReason>
              <b-icon
                v-if="row.item['pendingReason'] && row.item['status'] === 'PENDING'"
                :id="row.item['salesforceChildID']"
                v-b-popover.hover.html.top="popoverContent(row.item['pendingReason'])"
                class="ml-2"
                icon="info-circle-fill"
                scale="1"
                variant="info"
              ></b-icon>
            </template>
          </new-status-map>
        </div>
      </template>
      <template #cell(lastUpdated)="row">
        {{ formatDate(row.item['lastUpdated']) }}
      </template>
      <template #cell(by)="row">
        {{ row.item['changedBy'] }}
      </template>
    </b-table>
  </main>
</template>

<script>
  import tableFieldsMixin from '../../mixins/tableFieldsMixin';
  import moment from 'moment';
  import Status from '../../common/Status';
  import NewStatusMap from '../../common/NewStatusMap';

  export default {
    components: { Status, NewStatusMap },
    mixins: [tableFieldsMixin],
    props: {
      requests: Array,
      busy: Boolean,
      filter: { type: String, default: () => '' },
    },
    data() {
      return {
        perPage: 10,
        currentPage: 1,
        sortDesc: true,
        sortBy: 'statusMap',
      };
    },
    computed: {
      totalRows() {
        return this.requests.length;
      },
    },
    methods: {
      rowClass(item) {
        if (item !== null && item.salesforceChildID === this.filter) {
          return 'table-success';
        }
      },
      formatDate(date) {
        if (date == null || date === '') {
          return '';
        } else {
          return moment(date)
            .utc()
            .format('DD MMM YYYY h:mm A');
        }
      },
      popoverContent(pendingReason) {
        return {
          html: true,
          title: 'Pending Reason',
          content:
            pendingReason !== null ? pendingReason : 'No pending reason found for this request.',
        };
      },
    },
  };
</script>
